import React from 'react'
import { StyleSheet, Text, View, Image, SafeAreaView } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import AppIntroSlider from 'react-native-app-intro-slider';
import { useDimensions } from '@react-native-community/hooks'


const slides = [
    {
      key: '1',
      title: 'What is FromHereAfter and why do I need it?',
      underTitle: '',
      image: require('../assets/smartphone.png'),
      text: `Store your secret. We will keep it safe, only accessible by you. We will ask you each month to confirm that you are still alive and sane.`,    
    },
    {
      key: '2',
      title: '',
      image: require('../assets/siren.png'),
      text: 'When longer than a month no confirmation is received by us, a mail will be sent to the person you have mentioned as a trusted recipient.',
    },
    {
      key: '3',
      title: '',
      image: require('../assets/pin-code.png'),
      text: 'This person can then use the information to handle any affairs that need information that only you possessed. Important: you do not have to store a real secret or password, you can also store just a clue.',
    },
    {
      key: '4',
      title: 'Is it safe?',
      image: require('../assets/server.png'),
      text: `Yes. Your data is fully encrypted and stored on ultra-secure servers with the best security rules. By using a personalized token your data is available to you and only you. This token is only held by you. Also, don't worry about accidentaly disclosing your secrets. You still have a week after the month and we will remind you every day.` ,
    }
  ];


const IntroScreens = props => {
    const windowSize = useDimensions().window;

    const renderItem = ({ item }) => {
        return (
            <View style={styles.slide}>
              <Text style={{fontSize: windowSize.height >= 812 ? 33 : 25, color: '#404040', textAlign: 'center',}}>{item.title}</Text>
              <Image source={item.image} style={styles.image} />
              <Text style={{fontSize: windowSize.height >= 812 ? 20 : 15, color: '#404040', textAlign: 'center'}}>{item.underTitle}</Text>
              <Text style={{color: '#404040', textAlign: 'center', fontSize: windowSize.height >= 812 ? 20 : 15}}>{item.text}</Text>
            </View>
        );
    }
    
    const onDone = () => {
        props.done()
    }
    
    return (<SafeAreaView style={{flex: 1}}>
        <StatusBar style="auto" />
        <AppIntroSlider 
            renderItem={renderItem} 
            data={slides} 
            showSkipButton={true}
            showNextButton={true} 
            onDone={onDone}
            activeDotStyle={{backgroundColor: '#404040'}}
        />
        </SafeAreaView>)
}

export default IntroScreens

const styles = StyleSheet.create({
    slide: {
        flex: 1,
        alignItems: 'center',
        padding: 20,
        paddingBottom: 100,
        justifyContent: 'space-between'
        
      },
      image: {
        width: 175,
        height: 175,
        marginVertical: 32,
      },
})
